<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="venue-guide-container ps-0 py-0">
  <div class="d-flex justify-content-between align-items-center mb-3 pt-0">
    <h6 class="t-header-text mb-0">Events & Maps</h6>
    <div class="d-flex align-items-center gap-2" *ngIf="eventItems.length > 1">
      <button
        class="btn scroll-btn d-none d-md-inline-flex align-items-center justify-content-center"
        style="width: 30px; height: 24px; padding: 0"
        (click)="scrollVenue('left')"
        *ngIf="eventItems.length > 0"
        title="Scroll Left"
      >
        <i class="bi bi-arrow-left-short fs-4"></i>
      </button>
      <button
        class="btn scroll-btn d-none d-md-inline-flex align-items-center justify-content-center"
        style="width: 30px; height: 24px; padding: 0"
        (click)="scrollVenue('right')"
        *ngIf="eventItems.length > 0"
        title="Scroll Right"
      >
        <i class="bi bi-arrow-right-short fs-4"></i>
      </button>
      <a
        class="btn view-all-btn text-white px-3"
        [routerLink]="tenantService.getTenantPrefixedPath('event/all')"
        >View All</a
      >
    </div>
  </div>

  <div #venueScrollContainer class="venue-scroll">
    <ng-container *ngFor="let item of eventItems">
      <div class="venue-card text-decoration-none" [class.solo-event]="eventItems.length === 1" *ngIf="showItem(item)">
        <div class="venue-image-wrapper position-relative">
          <img
            *ngIf="item.photoUrl"
            [src]="item.photoUrl"
            alt="Venue"
            class="img-fluid"
          />

          <div class="venue-overlay text-white">
            <div class="px-3">
              <div class="d-flex align-items-center mb-2">
                <h5 class="fw-bold mb-0 me-auto">{{ item.title }}</h5>
                <a
                  *ngIf="item.hasLiveEvent && isLoaded"
                  class="live-badge d-flex align-items-center gap-1 text-decoration-none"
                  [href]="urlInput"
                  target="_blank"
                >
                  <span class="live-dot"></span>
                  <span class="live-text">Watch Event</span>
                </a>
                <div
                  *ngIf="showSplBadge(item)"
                  class="gradient-border-primary exclusive-badge"
                >
                  <span class="badge-text">Exclusive</span>
                </div>
              </div>

              <p class="mb-1 small">
                <i class="bi bi-clock me-2"></i>{{ item.date }}
                <span *ngIf="item.time">| {{ item.time }}</span>
              </p>
              <p
                class="mb-3 small text-venue"
                [class.transparent]="!item.venue"
              >
                <i class="bi bi-geo-alt me-2"></i>{{ item.venue }}
              </p>
            </div>

            <div class="d-flex w-100 justify-content-between gap-2 px-3 pb-2" >
              <a
                *ngIf="item.locationUrl"
                class="k-btn t-gray-gradient text-decoration-none text-center w-50"
                [href]="item.locationUrl"
                target="_blank"
              >
                Get Directions <i class="bi ms-2 bi-send"></i>
              </a>
              <a
                class="k-btn t-border-gradient-primary text-center text-decoration-none"
                [routerLink]="
                  tenantService.getTenantPrefixedPath(
                    'event/detail/' + item.key
                  )
                "
                *ngIf="item.tabs.length > 0"
              >
                View Details <i class="ms-2 arrow">&rarr;</i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
